import React, { useState } from 'react'
import { message } from 'antd'
import { Mutation } from 'react-apollo'
import {
  Div, H5, Input, Icon,
} from 'konsys-ui'
import {
  LoginContainerWrapper, LoginContentWrapper, LogoWrapper, LoginFormWrapper,
  Divider, SocialButtonWrapper, LoginButton, ButtonText,
} from './styled'
import { theme } from '../../styles/_variables'
import PATH from '../../constants/path'
import Logo from '../../images/logo/Boxsuit-Logo-01.png'
import { LOGIN } from '../../constants/graph/mutation'
import { setAccessToken, setRefreshToken } from '../../utils/local-data-service'

const SocialButton = ({
  type, icon, text, onClick,
}) => (
  <SocialButtonWrapper onClick={() => onClick()} type={type}>
    <Div display='inline-flex' alignItems='center' justifyContent='center'>
      <Icon color={theme.color.offWhite} fontSize={theme.fonts.size.label} icon={icon} />
    </Div>
    <H5 padding='16px 0 16px 0px' color={theme.color.offWhite}>{text}</H5>
  </SocialButtonWrapper>
)

const DoLogin = (
  func, email, password, callback,
) => {
  func({
    variables: {
      username: email,
      password,
      grant_type: 'password',
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
    },
  }).then((resp) => {
    if (resp.data.login.success) {
      setAccessToken(resp.data.login.createdAccessToken.access_token)
      setRefreshToken(resp.data.login.createdAccessToken.refresh_token)
      window.location = PATH.member
    } else {
      message.error(`ไม่สามารถเข้าสู่ระบบได้: ${resp.data.login.message || 'เกิดข้อผิดพลาด'}`)
      callback()
    }
  })
}

export const LoginModal = ({ innerRef, hideLogin }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [disabledButton, setDisabledButton] = useState(false)
  const validateEmail = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

  return (
    <LoginContentWrapper ref={innerRef}>
      <Div position='absolute' top='16px' right='16px' cursor='pointer' onClick={() => hideLogin()}>
        <Icon fontSize={theme.fonts.size.extraNormal} color={theme.color.grey} icon='far fa-times' />
      </Div>
      <Div textAlign='center'>
        <LogoWrapper src={Logo} />
        <H5
          color='#565757'
          textAlign='center'
          display='block'
        >คุณสามารถเข้าสู่ระบบเพื่อติดตาม หรือ ตรวจสอบ คำร้องขอใบเสนอราคา และคำสั่งพิมพ์ได้</H5>
      </Div>
      <Mutation
        mutation={LOGIN}
      >
      {
        doLogin => (
          <LoginFormWrapper>
            <Input
              width='100%'
              placeholder='Email'
              value={email}
              onChange={e => setEmail(e.target.value)}
              state={email !== '' && (!validateEmail.test(email) ? 'error' : 'success')}
              style={{
                fontSize: '24px',
              }}
              onKeyUp={(e) => {
                if (e.keyCode === 13 && email !== '' && validateEmail.test(email) && password !== '') {
                  setDisabledButton(true)
                  DoLogin(doLogin, email, password, () => {
                    setDisabledButton(false)
                  })
                }
              }}
            />
            <Input
              type='password'
              margin='8px 0'
              width='100%'
              placeholder='Password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{
                fontSize: '24px',
              }}
              onKeyUp={(e) => {
                if (e.keyCode === 13 && email !== '' && validateEmail.test(email) && password !== '') {
                  setDisabledButton(true)
                  DoLogin(doLogin, email, password, () => {
                    setDisabledButton(false)
                  })
                }
              }}
            />
            <Div textAlign='right'>
              <ButtonText color={theme.color.lightGrey} onClick={() => { window.location = PATH.forgetPassword }}>ลืมรหัสผ่าน?</ButtonText>
            </Div>
            <LoginButton
              margin='16px 0'
              inverse fullWidth
              buttonStyle="rectangle"
              text='เข้าสู่ระบบ'
              disabled={!(email !== '' && validateEmail.test(email)) || !password || disabledButton}
              onClick={() => {
                setDisabledButton(true)
                DoLogin(doLogin, email, password, () => {
                  setDisabledButton(false)
                })
              }}
            />
            <Div textAlign='right'>
              <ButtonText onClick={() => { window.location = PATH.register }} color={theme.color.lightGrey}>ลงทะเบียนใหม่</ButtonText>
            </Div>
          </LoginFormWrapper>
        )
      }
      </Mutation>
      <Divider />
      <SocialButton onClick={() => {
        window.location = process.env.REACT_APP_FACEBOOK_AUTH
      }} type='facebook' icon='fab fa-facebook-f' text='เข้าสู่ระบบด้วยบัญชี Facebook' />
      <SocialButton onClick={() => {
        window.location = process.env.REACT_APP_GOOGLE_AUTH
      }} type='google' icon='fab fa-google' text='เข้าสู่ระบบด้วยบัญชี Google' />
    </LoginContentWrapper>
  )
}

const Login = () => (
  <LoginContainerWrapper>
    <LoginModal />
  </LoginContainerWrapper>
)

export default Login



// WEBPACK FOOTER //
// ./src/pages/login/index.jsx